import { ErrorOutline } from '@insurancemenu/imenu-components-lib/dist/icons';
import styled, { css, CSSProp } from 'styled-components';
import { colors, typography } from '@insurancemenu/imenu-components-lib';

export const InvalidTotalRateStyled = styled.div`
  ${typography.regular[14]}
  color: ${colors.red[600]};
  display: flex;
  gap: 0.5rem;
  align-items: center;
  cursor: default;
  letter-spacing: 0.028rem;
`;

export const InvalidPLinesStyled = styled.b`
  margin: 0 0.5rem;
`;

export const ErrorOutlineStyled = styled(ErrorOutline)`
  flex-shrink: 0;
`;

export const TooltipErrorListStyled = styled.ul<{ $hasMultipleErrors: boolean }>`
  margin: 0;

  /* Display errors as a bulleted list when multiple errors exist */
  ${({ $hasMultipleErrors }): CSSProp =>
    $hasMultipleErrors
      ? css`
          padding-left: 1rem;
        `
      : css`
          padding-left: 0;
          list-style: none;
        `}
`;

export const TooltipErrorItemStyled = styled.li`
  ${typography.regular[14]};
  padding: 0;
`;
